import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'recovery-time-info',
  templateUrl: './recovery-time-info.component.html',
  styleUrls: ['./recovery-time-info.component.scss'],
  standalone: false,
})
export class RecoveryTimeInfoComponent implements OnInit {
  @Input() realTime: boolean = null
  @Input() snapshotTime: string = null

  constructor() {}

  ngOnInit(): void {}
}
